<template>
  <b-table
    id="users-table"
    :busy.sync="busy"
    :current-page="currentPage"
    :fields="fields"
    :filter="filter"
    :items="users"
    :per-page="perPage"
    empty-filtered-text="There are no users matching your request."
    head-variant="dark"
    hover
    responsive
    show-empty
    stacked="md"
    striped
    @filtered="onFiltered"
  >
    <template #table-caption>
      <div style="display: flex; justify-content: space-between">
        <p v-if="users" style="font-size: 16px">
          <strong>{{ currentUsersLength }}</strong>
          {{ currentUsersLength === 1 ? 'user' : 'users' }}
        </p>

        <b-pagination
          v-model="currentPage"
          :per-page="perPage"
          :total-rows="currentUsersLength"
          align="center"
          aria-controls="users-table"
          pills
        ></b-pagination>
      </div>
    </template>
    <template #table-busy>
      <div class="text-center text-secondary my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>Loading...</strong>
      </div>
    </template>
    <template #cell(actions)="data">
      <b-button pill size="sm" variant="outline-info" @click="editButtonClicked(data.item)">
        <b-icon icon="pencil"></b-icon>
        edit
      </b-button>
      <b-button pill size="sm" variant="outline-danger" @click="deleteButtonClicked(data.item)">
        <b-icon icon="trash"></b-icon>
        delete
      </b-button>
    </template>

    <template #cell(simRole)="data">
      <div class="inline">
        <span class="mr-1" v-html="data.value"></span>
        <b-icon
          v-if="data.value !== 'Admin'"
          :id="data.item.ID"
          v-b-popover.hover.html.top="popoverContent(data.item.simPermission)"
          icon="info-circle-fill"
          scale="1"
          variant="info"
        ></b-icon>
      </div>
    </template>
  </b-table>
</template>
<script>
  import { mapMutations } from 'vuex';

  export default {
    name: 'users-table',
    props: {
      busy: Boolean,
      filter: String,
      perPage: Number,
      users: Array,
    },
    data() {
      return {
        currentPage: 1,
        filteredUsersLength: 0,
        fields: [
          {
            key: 'name',
            sortable: true,
          },
          'email',
          {
            key: 'simRole',
            label: 'Role',
            sortable: true,
          },
          {
            key: 'actions',
            label: 'Actions',
          },
        ],
      };
    },
    computed: {
      currentUsersLength() {
        if (this.filteredUsersLength !== 0) {
          return this.filteredUsersLength;
        }
        return this.users.length;
      },
    },
    methods: {
      ...mapMutations({
        setForm: 'updateUserForm',
      }),
      editButtonClicked(user) {
        this.setForm(user);
        this.$router.push({
          name: 'salesforce-user-profile',
          params: { userId: user.ID },
          query: { tab: 'RoleAndPermissions' },
        });
      },
      deleteButtonClicked(user) {
        this.setForm(user);
        this.$bvModal.show('delete-user');
      },
      onFiltered(filteredItems) {
        this.filteredUsersLength = filteredItems.length;
      },
      popoverContent(permissions) {
        return {
          html: true,
          title: 'Permissions',
          content:
            permissions !== null ? permissions.join('<br>') : 'No permissions found for this user.',
        };
      },
    },
  };
</script>
